import {
  isPlanGatedQuizType,
  type PlanGatedQuizType,
} from '@/shared/plan/consts';
import { type QuizType } from '@/types';

type QuizWithOptionalType = {
  type?: string | null;
};

/**
 * 서버/폼이 섞어 쓰는 표기(대소문자·공백)를 정규화해 플랜 게이팅 대상 유형을 돌려준다.
 * 게이팅 대상이 아니면 `undefined` — 호출부가 유형별 문구·지표를 이걸로 고른다.
 */
export const resolveGatedQuizType = (
  type?: string | null,
): PlanGatedQuizType | undefined => {
  const normalized = type?.trim().toLowerCase() as QuizType | undefined;
  return normalized && isPlanGatedQuizType(normalized) ? normalized : undefined;
};

/** 플랜 제한에 걸린 문항 — `index` 는 폼 `quizList` 기준(0부터)이다. */
export type RestrictedProQuiz = {
  index: number;
  type: PlanGatedQuizType;
};

type ResolveRestrictedProQuizzesParams = {
  quizList: readonly QuizWithOptionalType[];
  hasProAccess: boolean;
};

/** 플랜 제한 문항을 목록 순서대로 모두 돌려준다. 안내 모달은 이 전체를, 수정 이동은 첫 항목을 쓴다. */
export const resolveRestrictedProQuizzes = ({
  quizList,
  hasProAccess,
}: ResolveRestrictedProQuizzesParams): RestrictedProQuiz[] => {
  if (hasProAccess) {
    return [];
  }

  return quizList.reduce<RestrictedProQuiz[]>(
    (restrictedQuizzes, quiz, index) => {
      const gatedType = resolveGatedQuizType(quiz.type);
      if (gatedType) {
        restrictedQuizzes.push({ index, type: gatedType });
      }

      return restrictedQuizzes;
    },
    [],
  );
};
